// React imports
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
// Material ui imports
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';

import { SparePart, buildSkuReference } from 'types/spare-part';

// Style imports
import TransferSkuAdditionStyle from '../styles/TransferSkuAdditionStyle';

const useCreationStyles = makeStyles(TransferSkuAdditionStyle);

type SkuListProps = {
  spareParts: SparePart[];
  removeSku: (sku: SparePart) => void;
};

const SkuList: React.FunctionComponent<SkuListProps> = ({
  spareParts,
  removeSku,
}: SkuListProps) => {
  const creationClasses = useCreationStyles();

  return (
    <div className={creationClasses.SkuListContainer}>
      {spareParts &&
        spareParts.length > 0 &&
        spareParts.map((sparePart, index) => (
          <div key={index} className={creationClasses.SkuItem}>
            <div className={creationClasses.skuItemText}>
              {`${buildSkuReference(sparePart)} - ${sparePart.designation}`}
            </div>
            <RemoveCircleOutlineIcon
              id={`remove-icon-${index}`}
              className={creationClasses.removeIcon}
              onClick={() => removeSku(sparePart)}
            />
          </div>
        ))}
    </div>
  );
};

export default SkuList;
